// External libraries
import gql from 'graphql-tag';
import {
  THREE_DOMAIN_SECURE_FRAGMENT,
  THREE_DS_2_CONTINGENCY_FRAGMENT,
} from '../fragments';

export const PRE_AUTHORIZE_PAYMENT_MUTATION = gql`
  mutation PreAuthorizePaymentMutation(
    $token: String!
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
  ) {
    preAuthorizePayment(token: $token) {
      declinedInstruments {
        id
        name
        normalizedProcessorResponse
      }
      paymentContingencies {
        ...threeDomainSecure
        ...threeDSContingencyData
      }
    }
  }
  ${THREE_DOMAIN_SECURE_FRAGMENT}
  ${THREE_DS_2_CONTINGENCY_FRAGMENT}
`;
